module.exports = __webpack_public_path__ + "static/media/4.17_preview.ef94caf9.png";